import { useMutation } from '@tanstack/react-query';
import type { WithdrawSuccessResponse } from '@/shared/types';
import { withdrawSbp } from '../requests';
import type {
  WithdrawSbpBodyRequest,
  WithdrawSbpErrorResponse,
} from '../../model';

interface UseWithdrawSbpOptions {
  onSuccess?: (data: WithdrawSuccessResponse) => void;
  onError?: (error: WithdrawSbpErrorResponse) => void;
}

export function useWithdrawSbp(options?: UseWithdrawSbpOptions) {
  const mutation = useMutation<
    WithdrawSuccessResponse,
    WithdrawSbpErrorResponse,
    WithdrawSbpBodyRequest
  >({
    mutationFn: withdrawSbp,
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });

  return {
    ...mutation,
  };
}
